var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7C13.25 9.10829 11.9151 11.1784 10.445 12.7955C9.7242 13.5884 9.00101 14.2395 8.45736 14.6926C8.28407 14.837 8.12961 14.9608 8 15.0621C7.87039 14.9608 7.71593 14.837 7.54264 14.6926C6.99899 14.2395 6.2758 13.5884 5.55495 12.7955C4.08485 11.1784 2.75 9.10829 2.75 7C2.75 4.1005 5.1005 1.75 8 1.75C10.8995 1.75 13.25 4.1005 13.25 7Z",
    stroke: "#262C2E",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1.5,
    fill: "#262C2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.a53b600ea76f4e2ce2a0d0ee02ca6251.svg";
export { ForwardRef as ReactComponent };